import { render, staticRenderFns } from "./LaunchpackProductReg.vue?vue&type=template&id=c8c2ba36&scoped=true"
import script from "./LaunchpackProductReg.vue?vue&type=script&lang=js"
export * from "./LaunchpackProductReg.vue?vue&type=script&lang=js"
import style0 from "./LaunchpackProductReg.vue?vue&type=style&index=0&id=c8c2ba36&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c2ba36",
  null
  
)

export default component.exports